import { 
    LOAD_LIST_SCHEDULE_MEDICAL, LOAD_A_SCHEDULE_MEDICAL, ADD_NEW_SCHEDULE_MEDICAL, UPDATE_A_SCHEDULE_MEDICAL, 
    DELETE_A_SCHEDULE_MEDICAL, CLEAR_A_SCHEDULE_MEDICAL_DETAIL, CLEAR_SCHEDULE_MEDICAL_ACTION_STATUS
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    scheduleMedicalList: [],
    scheduleMedicalDetail: null,
    totalCount: 0,
    limit: 10,
    skip: 0,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: ""
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_SCHEDULE_MEDICAL: {
            const { result, totalCount, limit, skip } = action.payload;
          
            return {
                ...state,
                scheduleMedicalList: result,
                totalCount,
                limit, 
                skip
            }
        }

        case LOAD_A_SCHEDULE_MEDICAL: {
            return {
                ...state,
                scheduleMedicalDetail: action.payload
            }
        }

        case ADD_NEW_SCHEDULE_MEDICAL: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                scheduleMedicalList: [
                    action.payload.data,
                    ...state.scheduleMedicalList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_SCHEDULE_MEDICAL: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                scheduleMedicalList: state.scheduleMedicalList.map(
                    item => item.id !== action.payload.data.id ? 
                        item : { ...item, status: action.payload.data?.status,  } 
                ),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_SCHEDULE_MEDICAL: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                scheduleMedicalList: state.scheduleMedicalList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_SCHEDULE_MEDICAL_DETAIL: {
            return {
                ...state,
                scheduleMedicalDetail: null,
            }
        }

        case CLEAR_SCHEDULE_MEDICAL_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        default:
            return state
    }
}